import React from "react";
import { useLocation } from "react-router";
import { gql, useQuery } from "@apollo/client";
import { toast } from "react-toastify";

import { ReportFullPage as V1FSCIFullPage } from "src/pages/reports/fsci/v1/report_full_page";
import { ReportFullPage as V2FSCIFullPage } from "src/pages/reports/fsci/v2/report_full_page";
import { ReportFullPage as V1FFIFullPage } from "src/pages/reports/ffi/v1/report_full_page";

export const GET_REPORT_QUERY = gql`
    query GetReport($searchType: String!, $searchYear: String!) {
        viewer {
            user {
                id
                school {
                    id
                    name
                    reports(
                        where: {
                            results: { exists: true }
                            type: { equalTo: $searchType }
                            year: { equalTo: $searchYear }
                        }
                    ) {
                        count
                        edges {
                            node {
                                id
                                year
                                version
                                type
                                results
                                constituentGroups
                                surveysCompleted
                            }
                        }
                    }
                }
            }
        }
    }
`;

/*
 * Main
 */

function parseString(str: string) {
    const matches = str.match(/\/reports\/(\w+)\/(\d{4}-\d{4})\/print/);
    if (matches && matches.length === 3) {
        const type = matches[1]; // 'ffi'
        const year = matches[2]; // '2023-2024'
        return { type, year };
    } else {
        return { type: "", year: "" };
    }
}

export const ReportFullPage = (): React.ReactElement => {
    const state = useLocation();
    const { type, year } = parseString(state.pathname);

    const { data, error, loading } = useQuery(GET_REPORT_QUERY, {
        variables: {
            searchType: type,
            searchYear: year,
        },
    });

    if (loading) {
        return <div>Loading...</div>;
    }

    if (error) {
        toast.error("Error loading report");
    }

    const school = data.viewer.user.school;
    const edges = data.viewer.user.school.reports.edges;

    if (!edges?.length || !edges[0].node?.results || Object.keys(edges[0].node.results).length === 0) {
        return <div>Report data is not yet available for this period.</div>;
    }

    const report = edges[0].node;

    return (
        <div>
            {report.type === "fsci" && report.version === "1" && (
                <V1FSCIFullPage report={{ value: report, tag: "v1_FSCI" }} school={school} />
            )}
            {report.type === "fsci" && report.version === "2" && (
                <V2FSCIFullPage report={{ value: report, tag: "v2_FSCI" }} school={school} />
            )}
            {report.type === "ffi" && report.version === "1" && (
                <V1FFIFullPage report={{ value: report, tag: "v1_FFI" }} school={school} />
            )}
        </div>
    );
};
